import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { useState } from 'react';
import styles from './index.module.less';
import Button from '@/components/button';
import TEXT from '@/constant/copyright.md';

const Footer = ({ withBanner = true }: { withBanner?: boolean }) => {
  const [showProtocol, setShowProtocol] = useState(false);

  const showProtocolPortal = () => {
    setShowProtocol(true);
  };
  const closeProtocolProtal = () => {
    setShowProtocol(false);
  };
  return (
    <div className={styles.footer}>
      {withBanner && (
        <div className={styles.banner}>
          <div className={styles.content}>
            <div className={styles.text}>
              图虫&IC Photo开放平台API多场景能力支持，多样资源海量供应
            </div>
            <Button className={styles.button}>立即试用</Button>
          </div>
        </div>
      )}
      {showProtocol &&
        createPortal(
          <div className={styles.protal} onClick={closeProtocolProtal}>
            <div
              className={styles.protalContent}
              onClick={e => e.stopPropagation()}
            >
              <div className={styles.protalText}>
                <div
                  className={classNames(styles.markdownBody, 'markdown-body')}
                  dangerouslySetInnerHTML={{ __html: TEXT }}
                />
              </div>
            </div>
          </div>,
          document.body,
        )}
      <div className={styles.copyright}>
        <div className={styles.copyrightContent}>
          <div className={styles.title}>开放平台API</div>
          <div>
            <Link to="/support/concat">联系我们</Link>
            <a onClick={showProtocolPortal}>授权协议</a>
            <Link to="/support/faq">常见问题</Link>
          </div>
        </div>
      </div>
      <div className={styles.footerTextWrapper}>
        <div className={styles.footerText}>
          <p>
            增值电信业务经营许可证：沪B2-20200060丨沪ICP备19019196号-1丨
            <a
              href="https://static-prod.ituchong.com/tc-common-fe-static/others/open/obj/eden-cn/aonpyfwvj_lcpahlyj_kh/ljhwZthlaukjlkulzlp/tuchong/图虫营业执照.pdf"
              target="_blank"
            >
              营业执照
            </a>
          </p>
          <p>
            网络文化经营许可证：沪网文【2022】1783-110号丨
            出版物经营许可证：新出发【沪】批字第Y7235号
          </p>
          <p>Copyright©2022 上海图虫网络科技有限公司</p>
          <p>举报邮箱：report@mail.tuchong.com</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
